import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface userAdministrationCompanyState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: userAdministrationCompanyState = {
  data: [],
  isLoading: false,
  error: null,
};

const userAdministrationCompanySlice = createSlice({
  name: 'userAdministrationCompany',
  initialState,
  reducers: {
    setUserAdministrationCompanies: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUserAdministrationCompanyLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUserAdministrationCompanyError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setUserAdministrationCompanies,
  setUserAdministrationCompanyLoading,
  setUserAdministrationCompanyError,
} = userAdministrationCompanySlice.actions;

export default userAdministrationCompanySlice.reducer;
